import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { HOME } from "@/constants/testIds";

export default function InquiryCTA() {
  return (
    <section
      data-testid={HOME.inquireSection}
      className="relative py-32 md:py-44"
    >
      <div className="max-w-[1180px] mx-auto px-6 md:px-12 text-center">
        <div className="eyebrow mb-8">Begin the Conversation</div>
        <h2 className="font-serif text-5xl md:text-7xl tracking-tight font-light leading-[0.95]">
          Your journey deserves <br />
          <em className="italic text-indigo_deep">an unhurried hand.</em>
        </h2>
        <p className="mt-10 max-w-xl mx-auto text-ink/70 font-light leading-relaxed">
          Every Indiora itinerary is privately composed. Share a few details
          with us — we will reply within two working days, never with a form.
        </p>
        <Link
          to="/contact"
          className="mt-12 inline-flex items-center gap-3 bg-ink text-ivory px-10 py-5 text-[11px] tracking-widest2 uppercase font-semibold hover:bg-indigo_deep transition-colors"
        >
          Plan a Private Journey
          <ArrowUpRight size={16} />
        </Link>
      </div>
    </section>
  );
}
